<template>
  <vue-easy-lightbox ref="lightbox" :visible="visibleViewer" :imgs="photosUrl" v-model:index="viewedImage"
                     @on-next="onNext" @hide="onHide" @onIndexChange="onIndexChange">
    <template v-slot:next-btn="{ next }">
      <q-btn flat @click="next" class="btn__next" :loading="loading" :disable="process" icon="navigate_next"/>
    </template>
    <template v-slot:prev-btn="{ prev }">
      <q-btn flat @click="prev" class="btn__prev" :disable="process" icon="navigate_before"/>
    </template>
    <template v-slot:toolbar="{ toolbarMethods }" v-if="!shared">
      <div class="row absolute-bottom justify-center bg-white q-gutter-xs q-pa-xs ">
        <q-checkbox label="Использовать подпись" :model-value="hasCaption"
                    @update:model-value="photoStore.updateUseCaption"/>
        <q-btn flat icon="delete" :loading="process" @click="deletePhoto" label="Удалить"/>
        <q-input :disable="process" :model-value="viewedImageDate"
                 @update:model-value="onViewedPhotoDateUpdate"
                 label="Дата выполнения" :rules="[requiredRule]" debounce="500">
          <template v-slot:prepend>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-date :model-value="viewedImageDate"
                        @update:model-value="onViewedPhotoDateUpdate" :mask="VIEWED_DATE_MASK">
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>

          <template v-slot:append>
            <q-icon name="access_time" class="cursor-pointer">
              <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                <q-time :model-value="viewedImageDate" with-seconds
                        @update:model-value="onViewedPhotoDateUpdate" :mask="VIEWED_DATE_MASK"
                        format24h>
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                  </div>
                </q-time>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
        <form @submit.prevent.stop="updateLocation" class="row q-gutter-xs">
          <q-input :disable="process" v-model="currentPhoto.longitude" :rules="[longitudeRule]" label="Долгота"/>
          <q-input :disable="process" v-model="currentPhoto.latitude" :rules="[latitudeRule]" label="Широта"/>
          <div class="text-center items-center justify-center row">
            <q-btn type="submit" label="Обновить геолокацию"></q-btn>
          </div>
        </form>

      </div>
    </template>
  </vue-easy-lightbox>
</template>

<script setup lang="ts">
import {usePhotoStore} from "../store/photo.js";
import {storeToRefs} from "pinia";
import {computedEager, useEventBus} from "@vueuse/core";
import {photoKey} from "../util/events.js";
import {computed, ref} from "vue";
import {requiredRule, longitudeRule, latitudeRule} from "../util/rules";
import {useDayJs} from "../composables/dayjs";
import {useUpdatePhotoLocation} from "../composables/task";
import {useRouteParams} from "@vueuse/router";
import {useQuasar} from "quasar";

const dayJs = useDayJs()
const photoStore = usePhotoStore()
const {open, visibleViewer, photos, shared, viewedImage, photosUrl, loading, last} = storeToRefs(photoStore)
const $q = useQuasar()
const VIEWED_DATE_MASK = "YYYY-MM-DD HH:mm:ss"
const VIEWED_DATE_REGEXP = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

function onHide() {
  visibleViewer.value = false
}

const projectId = useRouteParams('projectId', undefined, {transform: Number})

const photoEvent = useEventBus(photoKey)
const lightbox = ref()
const process = ref(false)
const currentPhoto = computed(() => photos.value[viewedImage.value])
const viewedImageDate = computed(() => dayJs.utc(currentPhoto.value.createdAt).local().format(VIEWED_DATE_MASK))
const hasCaption = computed(() => currentPhoto.value.usedCaption)

const {execute} = useUpdatePhotoLocation(projectId, currentPhoto)

function onViewedPhotoDateUpdate(value: unknown) {
  if (typeof value !== "string" || !VIEWED_DATE_REGEXP.test(value)) {
    return
  }
  photoStore.updateViewedPhotoDate(value)
}

function onNext(oldIndex: number, newIndex: number) {
  if (newIndex >= photosUrl.value.length - 1) {
    photoEvent.emit('load')
  }
}

function onIndexChange(oldIndex: number, newIndex: number) {
  viewedImage.value = newIndex
}

async function updateLocation() {
  await execute(true)
  $q.notify({
    type: "positive",
    message: "Успех"
  })
}

async function deletePhoto() {
  $q.dialog({
    title: "Удалить фото",
    message: "Вы уверены, что хотите удалить фото?",
    ok: "Да",
    cancel: "Нет"
  }).onOk(async () => {
    process.value = true
    photoStore.deletePhoto(currentPhoto)
        .finally(() => {
          process.value = false
        })
  })
}
</script>

<style scoped></style>
